module.exports = __webpack_public_path__ + "img/sign.5df34894.svg";